/** Stable ModuleCode vocabulary — must match backend ProductModuleCodes. */
export const productModuleCodes = Object.freeze({
    CORE_ATS: "CORE_ATS",
    AI_PLATFORM: "AI_PLATFORM",
    MOLASSIST: "MOLASSIST",
    AI_AGENTS: "AI_AGENTS",
    KNOWLEDGE_RAG: "KNOWLEDGE_RAG",
    TALENT_CRM: "TALENT_CRM",
    TALENT_REDISCOVERY: "TALENT_REDISCOVERY",
    ADVANCED_ASSESSMENT: "ADVANCED_ASSESSMENT",
    EVIDENCE_PROVENANCE: "EVIDENCE_PROVENANCE",
    EXPLAINABLE_MATCH: "EXPLAINABLE_MATCH",
    TRUST_VERIFICATION: "TRUST_VERIFICATION",
    SLA_COMMAND_CENTER: "SLA_COMMAND_CENTER",
    CANDIDATE_PORTAL: "CANDIDATE_PORTAL",
    QUALITY_OF_HIRE: "QUALITY_OF_HIRE",
});

export const ENABLED_MODULE_CODES_STORAGE_KEY = "EnabledModuleCodes";
export const ENABLED_MODULES_CHANGED_EVENT = "moltechr:enabled-modules-changed";

export const notifyEnabledModulesChanged = () => {
    try {
        window.dispatchEvent(new Event(ENABLED_MODULES_CHANGED_EVENT));
    } catch {
        /* ignore */
    }
};
